module.exports = __webpack_public_path__ + "static/a-xx-037-art-95a541993695deaf6cb22af37781bf3e.jpg";